import { IVerifiedAddress } from '../../types/Shipping.types';

import { IShippingAddress } from './shipping.types';

export const transformVerifiedAddress = (verifiedAddress: IVerifiedAddress): Omit<IShippingAddress, 'phone'> => {
  const { zipcode, city, stateName, countryId, addressLines, organization } = verifiedAddress;
  return {
    address: addressLines.join(', '),
    address2: '',
    city,
    state: stateName,
    zipcode,
    country: countryId,
    company: organization,
  };
};
